import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "indicator" }
const _hoisted_2 = { class: "btn btn-neutral btn-sm" }
const _hoisted_3 = { class: "px-4 py-3 flex flex-col gap-3 min-w-[400px] md:min-w-[512px]" }
const _hoisted_4 = { class: "flex justify-center items-center gap-3" }

import { computed } from "vue";
import { assertUnreachable } from "@/utils";
import { KeyAction } from "@/keyboard";
import {
  ConditionValue,
  ConditionTypeLogic,
  isCondLed,
  isCondRole,
  isCondUsbOn,
  isCondPressed,
  isCondKeyAction,
  isCondKeyPressed,
  isCondLayer,
  isCondAlways,
  isCondBootloaderAllowed,
} from "@/keyboard/leds";
import PopupButton from "@/components/utils/PopupButton.vue";
import ConditionTypeEdit from "@/components/leds/ConditionTypeEdit.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConditionTypeButton',
  props: {
    modelValue: {},
    parentLogic: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;



const keyActionText = (a: KeyAction): string =>
  a == "Trans"
    ? "Transparent"
    : a == "DefaultLayer"
    ? "Default Layer"
    : a == "MultipleActions"
    ? "Multiple Actions"
    : a == "MultipleKeyCodes"
    ? "Multiple Keycodes"
    : a;

const text = computed(() => {
  const c = props.modelValue;
  if (isCondAlways(c)) return "Always";
  else if (isCondUsbOn(c)) return "USB ON";
  else if (isCondLed(c)) return `${c.Led}`;
  else if (isCondRole(c)) return `${c.Role}`;
  else if (isCondPressed(c)) return "Pressed";
  else if (isCondKeyAction(c)) return `${keyActionText(c.KeyAction)}`;
  else if (isCondKeyPressed(c))
    return `Pressed (${c.KeyPressed[0]}, ${c.KeyPressed[1]})`;
  else if (isCondLayer(c)) return `Layer ${c.Layer}`;
  else if (isCondBootloaderAllowed(c)) return "Boot Allowed";
  else return assertUnreachable(c);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupButton, {
    placement: "top",
    offset: 3
  }, {
    button: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(text.value), 1)
      ])
    ]),
    popup: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ConditionTypeEdit, {
          modelValue: _ctx.modelValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = (v) => _ctx.$emit('update:modelValue', v))
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.parentLogic != 'Not')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-sm btn-primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', { Not: _ctx.modelValue })))
              }, " Not "))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-sm btn-primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', { And: [_ctx.modelValue, 'Always'] })))
          }, " And "),
          _createElementVNode("button", {
            class: "btn btn-sm btn-primary",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:modelValue', { Or: [_ctx.modelValue, 'Always'] })))
          }, " Or "),
          _createElementVNode("button", {
            class: "btn btn-sm btn-neutral",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:modelValue', null)))
          }, " Delete ")
        ])
      ])
    ]),
    _: 1
  }))
}
}

})